import { Card, Row, Col, Select, DatePicker, Button, Typography } from "antd";
import { ReloadOutlined, BarChartOutlined, TableOutlined } from "@ant-design/icons";
import { useMemo } from "react";
const { RangePicker } = DatePicker;
const { Text } = Typography;
export default function DashboardFilters({ movimientos, filters, onFilterChange, onReset, viewMode, setViewMode }) {

    const proyectos = useMemo(() =>
        [...new Set(movimientos.map(m => m.proyecto))],
        [movimientos]
    );
    const tiposEntrega = useMemo(() =>
        [...new Set(movimientos.map(m => m.tipo_entrega))],
        [movimientos]
    );

    const departamentos = useMemo(() =>
        [...new Set(movimientos.map(m => m.departamento))],
        [movimientos]
    );

    const municipios = useMemo(() => {
        if (!filters.departamento) return [];
        return [
            ...new Set(
                movimientos
                    .filter(m => m.departamento === filters.departamento)
                    .map(m => m.municipio)
            )
        ];
    }, [movimientos, filters.departamento]);

    const productos = useMemo(() =>
        [...new Set(movimientos.map(m => m.nombre_producto))],
        [movimientos]
    );

    const handleReset = () => {
        onReset();
    };

    return (
        <Card
            style={{
                borderRadius: 16,
                padding: 12,
                background: "#FFFFFF",
                boxShadow: "0 4px 14px rgba(4, 41, 86, 0.06)",
                marginBottom: 20
            }}
        >
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "#042956",
                            fontWeight: 500
                        }}
                    >
                        Rango de fecha
                    </Text>
                    <RangePicker
                        value={filters.fecha || null}
                        style={{ width: "100%" }}
                        onChange={(dates) => onFilterChange("fecha", dates)}
                        size="large"
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "#042956",
                            fontWeight: 500
                        }}
                    >
                        Proyecto
                    </Text>
                    <Select
                        placeholder="Selecciona proyecto"
                        allowClear
                        showSearch
                        size="large"
                        value={filters.proyecto || null}
                        style={{ width: "100%" }}
                        onChange={(value) => onFilterChange("proyecto", value)}
                        options={proyectos.map((p) => ({
                            value: p,
                            label: p
                        }))}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "#042956",
                            fontWeight: 500
                        }}
                    >
                        Departamento
                    </Text>
                    <Select
                        placeholder="Selecciona departamento"
                        allowClear
                        showSearch
                        size="large"
                        value={filters.departamento || null}
                        style={{ width: "100%" }}
                        onChange={(value) => {
                            onFilterChange("departamento", value);
                            onFilterChange("municipio", null);
                        }}
                        options={departamentos.map((d) => ({
                            value: d,
                            label: d
                        }))}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "#042956",
                            fontWeight: 500
                        }}
                    >
                        Municipio
                    </Text>
                    <Select
                        placeholder="Selecciona municipio"
                        allowClear
                        showSearch
                        size="large"
                        disabled={!filters.departamento}
                        value={filters.municipio || null}
                        style={{ width: "100%" }}
                        onChange={(value) => onFilterChange("municipio", value)}
                        options={municipios.map((m) => ({
                            value: m,
                            label: m
                        }))}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "#042956",
                            fontWeight: 500
                        }}
                    >
                        Producto
                    </Text>
                    <Select
                        placeholder="Selecciona producto"
                        allowClear
                        showSearch
                        size="large"
                        value={filters.producto || null}
                        style={{ width: "100%" }}
                        onChange={(value) => onFilterChange("producto", value)}
                        options={productos.map((p) => ({
                            value: p,
                            label: p
                        }))}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "#042956",
                            fontWeight: 500
                        }}
                    >
                        Tipo de entrega
                    </Text>
                    <Select
                        placeholder="Selecciona tipo"
                        allowClear
                        showSearch
                        size="large"
                        value={filters.tipo_entrega || null}
                        style={{ width: "100%" }}
                        onChange={(value) => onFilterChange("tipo_entrega", value)}
                        options={tiposEntrega.map((t) => ({
                            value: t,
                            label: t
                        }))}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "transparent",
                            fontWeight: 500,
                            userSelect: "none"
                        }}
                    >
                        Acción
                    </Text>
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={handleReset}
                        block
                        size="large"
                        style={{
                            background: "#042956",
                            borderColor: "#042956",
                            color: "#FFFFFF",
                            fontWeight: 600,
                            borderRadius: 10
                        }}
                    >
                        Limpiar filtros
                    </Button>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Text
                        style={{
                            display: "block",
                            marginBottom: 6,
                            color: "#042956",
                            fontWeight: 500
                        }}
                    >
                        Visualización
                    </Text>

                    <Button
                        icon={viewMode === "charts" ? <TableOutlined /> : <BarChartOutlined />}
                        onClick={() =>
                            setViewMode(viewMode === "charts" ? "table" : "charts")
                        }
                        block
                        size="large"
                        style={{
                            background: "#042956",
                            borderColor: "#042956",
                            color: "#ffffff",
                            fontWeight: 600,
                            borderRadius: 10
                        }}
                    >
                        {viewMode === "charts"
                            ? "Ver tabla"
                            : "Ver gráficas"}
                    </Button>
                </Col>
            </Row>
        </Card>
    );
}